export default "__VITE_ASSET__D5ts4YSM__"